export const TimelineTypes = {
    gateway: 'gateway',
    customer: 'customer',
    transaction: 'transaction',
    order: 'order',
    invoice: 'invoice',
    creditMemo: 'credit-memo',
};

export const TimelineTypeLabels = {
    [TimelineTypes.gateway]: 'gateway account',
    [TimelineTypes.customer]: 'customer',
    [TimelineTypes.transaction]: 'transaction',
    [TimelineTypes.order]: 'order',
    [TimelineTypes.invoice]: 'invoice',
    [TimelineTypes.creditMemo]: 'credit memo',
};

export const TimelineResourceMap = {
    [TimelineTypes.customer]: 'customers',
    [TimelineTypes.gateway]: 'gatewayAccounts',
    [TimelineTypes.transaction]: 'transactions',
    [TimelineTypes.order]: 'subscriptions',
    [TimelineTypes.invoice]: 'invoices',
    [TimelineTypes.creditMemo]: 'creditMemos',
};

export default {
    TimelineTypes,
    TimelineTypeLabels,
    TimelineResourceMap,
};
